import {
  ADD_RESPONSE_IN_REPORT,
  ADD_SELECTED_RESPONSE,
  FETCH_ACTS,
  FETCH_ALL,
  FETCH_BID,
  FETCH_CURRENT_REPORT,
  FETCH_FIX_BLOCK_TTNS,
  FETCH_LOAD_DAYS,
  FETCH_PAYMENT,
  FETCH_REPORTS,
  FETCH_REPORT_MODAL,
  FETCH_RESPONSES,
  FETCH_RESPONSES_NOT_ADDED,
  FETCH_TTNS,
  REMOVE_REPORT,
  SET_LOADED,
  SET_LOADED_ADD_REPORT,
  SET_LOADED_REPORTS,
  SET_LOADED_RESPONSES,
  SET_LOADED_RESPONSES_NOT_ADDED,
  SET_LOADED_TTNS,
  SET_PAGINATION,
  SET_PROGRESS_BAR,
  SET_RESPONSES_NOT_ADDED,
  SET_SEARCH,
  SET_STATUS_DOWNLOAD,
} from '@/store/actions/reports'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const BidAPI = RepositoryFactory.get('bids')
const ReportsAPI = RepositoryFactory.get('totalReport')
const ResponsesAPI = RepositoryFactory.get('responses')
const TtnsAPI = RepositoryFactory.get('ttn')
const DocAPI = RepositoryFactory.get('doc')
const PaymentsAPI = RepositoryFactory.get('payments')

export default {
  namespaced: true,
  state: {
    reports: [],
    pagination: {},
    currentReport: {},
    bid: {},
    loadDays: [],
    responses: [],
    responsesNotAdded: [],
    loaded: false,
    loadedReports: false,
    loadedResponses: false,
    loadedAddResponse: true,
    loadedResponsesNotAdded: true,
    fixBlockTtns: [],
    loadedTtns: true,
    search: '',
    progressBar: 0,
    statusDownload: '',
    reportModal: {
      acts: {
        items: [],
        loading: false,
      },
      ttns: {
        items: [],
        loading: false,
      },
      payment: {
        items: [],
        loading: false,
      },
    },
    reportsPageChecked: [],
  },
  getters: {
    getCurrentReport: state => state.currentReport,
    getLoadDays: state => state.loadDays,
    getResponses: state => state.responses,
    getBid: state => state.bid,
    getReports: state => state.reports,
    getLoaded: state => state.loaded,
    getLoadedReports: state => state.loadedReports,
    getLoadedResponses: state => state.loadedResponses,
    getLoadedAddResponse: state => state.loadedAddResponse,
    getLoadedResponsesNotAdded: state => state.loadedResponsesNotAdded,
    getLoadedTtns: state => state.loadedTtns,
    getSearch: state => state.search,
    getProgressBar: state => state.progressBar,
    getStatusDownload: state => state.statusDownload,
    getResponsesNotAdded: state => state.responsesNotAdded,
    getFixBlockTtns: state => state.fixBlockTtns,
    getPagination: state => state.pagination,
    getReportModal: state => (id, type) =>
      state.reportModal[type].items.filter(item => item.response_id === id),
    getReportsPageChecked: state => state.reportsPageChecked
  },
  mutations: {
    [FETCH_BID]: (state, payload) => (state.bid = payload),
    [FETCH_REPORTS]: (state, payload) => (state.reports = payload),
    [FETCH_CURRENT_REPORT]: (state, payload) => (state.currentReport = payload),
    [FETCH_LOAD_DAYS]: (state, payload) => (state.loadDays = payload),
    [FETCH_RESPONSES]: (state, payload) => (state.responses = payload),
    [FETCH_RESPONSES_NOT_ADDED]: (state, payload) =>
      (state.responsesNotAdded = payload),
    [FETCH_FIX_BLOCK_TTNS]: (state, payload) => (state.fixBlockTtns = payload),
    [FETCH_REPORT_MODAL]: (state, { data, type }) =>
      (state.reportModal[type].items = data),
    [SET_LOADED]: (state, payload) => (state.loaded = payload),
    [SET_LOADED_REPORTS]: (state, payload) => (state.loadedReports = payload),
    [SET_LOADED_RESPONSES]: (state, payload) =>
      (state.loadedResponses = payload),
    [SET_LOADED_ADD_REPORT]: (state, payload) =>
      (state.loadedAddResponse = payload),
    [SET_LOADED_RESPONSES_NOT_ADDED]: (state, payload) =>
      (state.loadedResponsesNotAdded = payload),
    [SET_LOADED_TTNS]: (state, payload) => (state.loadedTtns = payload),
    [SET_SEARCH]: (state, payload) => (state.search = payload),
    [SET_PROGRESS_BAR]: (state, payload) => (state.progressBar = payload),
    [SET_STATUS_DOWNLOAD]: (state, payload) => (state.statusDownload = payload),
    [SET_PAGINATION]: (state, payload) => (state.pagination = payload),
    [FETCH_ACTS]: (state, payload) => (state.reportModal.acts.items = payload),
    [SET_RESPONSES_NOT_ADDED]: (state, payload) =>
      (state.responsesNotAdded = payload),
    [ADD_SELECTED_RESPONSE]: (state, payload) => state.responses.push(payload),
    updateBid(state, { data }) {
      if (data) {
        state.bid = { ...state.bid, ...data }
      }
    },
    setReportsPageChecked(state, list) {
      state.reportsPageChecked = list
    },
  },
  actions: {
    [FETCH_REPORTS]: async ({ commit }, payload) => {
      commit(SET_LOADED_REPORTS, true)
      ReportsAPI.getList(payload)
        .then(response => {
          commit(FETCH_REPORTS, response.data.items)
          commit(SET_PAGINATION, response.data._meta)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADED_REPORTS, false))
    },
    [FETCH_BID]: ({ commit }, payload) =>
      BidAPI.getBid(payload)
        .then(response => commit(FETCH_BID, response.data))
        .catch(e => console.log(e)),
    [FETCH_CURRENT_REPORT]: async ({ commit }, payload) => {
      await ReportsAPI.get(payload)
        .then(response => commit(FETCH_CURRENT_REPORT, response.data.items[0]))
        .catch(e => console.log(e))
    },
    [FETCH_LOAD_DAYS]: ({ commit, state }) => {
      let loadDaysIds = Object.values(state.currentReport.load_day_ids)
      let loadDays = state.bid['load-days'].filter(loadDay =>
        loadDaysIds.includes(String(loadDay.id)),
      )

      commit(FETCH_LOAD_DAYS, loadDays)
    },
    [FETCH_RESPONSES]: async ({ commit, dispatch, state }, page) => {
      commit(SET_LOADED_RESPONSES, true)
      await ResponsesAPI.fetchReports({
        report_id: state.currentReport['id'],
        page,
      })
        .then(({ data }) => {
          commit(SET_PAGINATION, data.responses_meta)
          const responses = data.responses
          const ids =
            responses && responses.length ? responses.map(f => f.id) : null

          if (ids) {
            dispatch(FETCH_ACTS, ids)
            dispatch(FETCH_TTNS, ids)
            dispatch(FETCH_PAYMENT, ids)
          }
          commit(FETCH_RESPONSES, responses)
          commit(SET_LOADED_RESPONSES, false)
        })
        .catch(e => console.log('e', e))
    },
    [FETCH_ACTS]: async ({ commit }, payload) => {
      const type = 'acts'
      const ActsListPromise = payload.map(id =>
        DocAPI.getDocument('responses', id, 'works_act'),
      )

      Promise.all(ActsListPromise)
        .then(res => {
          const { data: allActs } = res.reduce(
            (a, b) => ({
              data: [
                ...a.data,
                ...b.data.map(d => ({
                  ...d,
                  response_id: b.config.params.rel_id,
                })),
              ],
            }),
            { data: [] },
          )

          commit(FETCH_REPORT_MODAL, { data: allActs, type })
        })
        .catch(e => console.log(e))
        .finally()
    },
    [FETCH_TTNS]: async ({ commit }, payload) => {
      const type = 'ttns'

      TtnsAPI.getList(payload)
        .then(response => {
          commit(FETCH_REPORT_MODAL, { data: response.data, type })
        })
        .catch(e => console.log(e))
    },
    [FETCH_FIX_BLOCK_TTNS]: async ({ commit }, payload) => {
      commit(SET_LOADED_TTNS, false)
      TtnsAPI.getList(payload)
        .then(response => {
          commit(FETCH_FIX_BLOCK_TTNS, response.data)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADED_TTNS, true))
    },
    [FETCH_PAYMENT]: async ({ commit }, payload) => {
      const type = 'payment'

      PaymentsAPI.listById(payload)
        .then(response => {
          commit(FETCH_REPORT_MODAL, { data: response.data, type })
        })
        .catch(e => console.log(e))
    },
    [FETCH_ALL]: async ({ dispatch, commit }, payload) => {
      await dispatch(FETCH_CURRENT_REPORT, payload.reportId).then(async () => {
        await dispatch(FETCH_BID, payload.bidId).then(async () => {
          await dispatch(FETCH_LOAD_DAYS).then(async () => {
            await dispatch(FETCH_RESPONSES, payload.currentPage).then(() =>
              commit(SET_LOADED, true),
            )
          })
        })
      })
    },
    [FETCH_RESPONSES_NOT_ADDED]: async ({ commit }, payload) => {
      commit(SET_LOADED_RESPONSES_NOT_ADDED, false)
      await ReportsAPI.getResponsesIdsWhichNotAdd(payload)
        .then(async response => {
          await ResponsesAPI.getResponsesByIdsForTotalReportNotAdded(
            response.data['available-responses'],
          )
            .then(response => {
              commit(FETCH_RESPONSES_NOT_ADDED, response.data.items)
              commit(SET_LOADED_RESPONSES_NOT_ADDED, true)
            })
            .catch(e => console.log('e', e))
        })
        .catch(e => console.log('e', e))
    },
    [SET_SEARCH]: ({ commit }, payload) => commit(SET_SEARCH, payload),
    [SET_PROGRESS_BAR]: ({ commit }, payload) =>
      commit(SET_PROGRESS_BAR, payload),
    [SET_STATUS_DOWNLOAD]: ({ commit }, payload) =>
      commit(SET_STATUS_DOWNLOAD, payload),
    [ADD_RESPONSE_IN_REPORT]: async ({ commit, state }, payload) => {
      const modifiedResponsesNotAdded = state.responsesNotAdded.filter(
        item => item.id !== payload.responseId,
      )
      const selectedResponse = state.responsesNotAdded.filter(
        item => item.id === payload.responseId,
      )

      commit(SET_RESPONSES_NOT_ADDED, modifiedResponsesNotAdded)
      await ReportsAPI.addResponse(payload.reportId, payload.responseId)
        .then(async () => {
          commit(ADD_SELECTED_RESPONSE, selectedResponse[0])
        })
        .catch(e => console.log('error', e))
    },
    [REMOVE_REPORT]: ({ commit, state }, payload) => {
      const actualResponses = state.responses.filter(
        item => item.id !== payload,
      )

      commit(FETCH_RESPONSES, actualResponses)
    },
  },
}
